import { jsx, jsxs } from "react/jsx-runtime";
import {
  __css,
  mergeClasses,
  Skeleton,
  SkeletonItem,
  tokens
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import { useVisuallyHiddenStyles } from "../internal/styles.js";
const useStyles = __css({"root":{"mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f1wn3y0l"},"row":{"mc9l5x":"f22iagw","Bt984gj":"f122n59","i8kkvl":"f1xcgk68","Bnt446c":0,"B1hrpyx":0,"Fjva8n":"f12n3xlw"},"comfortable":{"sshi5w":"f1w5jphr"},"compact":{"sshi5w":"f1nxs5xn"},"lines":{"mc9l5x":"f22iagw","Beiy3e4":"f1vx9l62","Belr9w4":"f778t4r","Bh6795r":"fqerorx"}});
function SkeletonList({
  count = 5,
  avatar = false,
  density = "comfortable",
  className
}) {
  const { t } = useTranslation("ui");
  const styles = useStyles();
  const hidden = useVisuallyHiddenStyles();
  const rows = Array.from({ length: count }, (_, index) => index);
  return /* @__PURE__ */ jsxs("div", { role: "status", "aria-busy": "true", className: mergeClasses(styles.root, className), children: [
    /* @__PURE__ */ jsx("span", { className: hidden.hidden, children: t("components.common.loading") }),
    rows.map((index) => /* @__PURE__ */ jsxs(
      Skeleton,
      {
        "aria-hidden": "true",
        role: "presentation",
        className: mergeClasses(styles.row, styles[density]),
        children: [
          avatar ? /* @__PURE__ */ jsx(SkeletonItem, { shape: "circle", size: density === "compact" ? 24 : 32 }) : null,
          /* @__PURE__ */ jsx("div", { className: styles.lines, children: /* @__PURE__ */ jsx(SkeletonItem, { size: 12 }) })
        ]
      },
      index
    ))
  ] });
}
export {
  SkeletonList
};
//# sourceMappingURL=skeleton-list.js.map

import "/opt/batiflow/app/packages/ui/dist/components/skeleton-list/skeleton-list.griffel.css";